import SignUp from 'modules/auth/signup';
import AuthWrapper from '../authWrapper';

const SignUpPage = () => {
  return (
    <AuthWrapper>
      <SignUp />
    </AuthWrapper>
  );
};

export default SignUpPage;
